module.exports = __webpack_public_path__ + "img/icon_inventario_padres.d149a4a3.svg";